const urlParams = new URLSearchParams(window.location.search);
const dropdown = document.querySelectorAll('.dropdown');
if (dropdown) {
  dropdown.forEach(function (element) {
    const select = element.querySelector('select');
    const category = select.getAttribute('name');
    const baseURL = select.dataset.url;
  
    select.addEventListener('change', function () {
      const value = select.value;
  
      if (value) {
        urlParams.set(category, value);
      } else {
        urlParams.delete(category);
      }
  
      const params = urlParams.toString();
      window.location = baseURL + (params ? '?' + params : '');
    });
  })
}
